/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCardSkinRequest} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_card_skin.pb'
import {GetCardSkinResponse} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_card_skin.pb'


export const getCardSkin = (request: GetCardSkinRequest, options?: CashRequestOptions) => post<GetCardSkinRequest, GetCardSkinResponse>("/2.0/cash/get-card-skin", request, {...options, rejectOnError: true })